import { TapesUploadedTableFragments } from 'features/loanTape/components/TapesUploadedTable';

import { gql } from '@apollo/client';

const GET_UPLOADED_FILES_WITH_HEADERS = gql`
  query GetUploadedFilesWithHeaders {
    user {
      id
      company {
        id
        loan_tapes {
          id
          state
          ...TapesUploadedTableFile
        }
      }
    }
  }
  ${TapesUploadedTableFragments.loanTape}
`;

export { GET_UPLOADED_FILES_WITH_HEADERS };
